import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';

// Public web SDK config — embedded in the bundle is fine; Firebase enforces
// security via Auth rules + admin SDK token verification, not these values.
const firebaseConfig = {
  apiKey: 'AIzaSyAu5ccaAPkM9mwfuohTgpyqEPaoIEBmPzg',
  authDomain: 'lexcrm-prod-4e14b.firebaseapp.com',
  projectId: 'lexcrm-prod-4e14b',
  storageBucket: 'lexcrm-prod-4e14b.firebasestorage.app',
  messagingSenderId: '564442692693',
  appId: '1:564442692693:web:f861f2749ca00c5dc268dc',
};

export const firebaseApp = initializeApp(firebaseConfig);
export const firebaseAuth = getAuth(firebaseApp);
export const googleProvider = new GoogleAuthProvider();
